import {Component, Inject, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Subscription} from "rxjs";
import {validationPattern} from "@app/helper/validation.formcontrol";
import {CacheObjectService, EventTrackerService, HttpService, LogService} from "@app/core";
import {IndicatorService} from "@app/shared";
import {UserModel} from "@app/app/profile/usermodel";
import {UserService} from "@app/app/profile/user-service.service";
import {TokenService} from "@app/core/token/token.service";
import {HttpParams} from "@angular/common/http";
import {iNotification, NotificationService} from "@app/shared/notification/notification.service";
import {DOCUMENT, Location, PlatformLocation} from "@angular/common";
import {Router} from "@angular/router";
import {slideInUpOnEnterAnimation} from "@app/animation/slideDownToUp";

@Component({
  selector: 'navaar-send-feedback',
  templateUrl: './send-feedback.component.html',
  styleUrls: [
    '../feedback.component.scss',
    '../../profile/profile-edit/profile-edit.component.scss'
  ],
  animations: [slideInUpOnEnterAnimation({anchor: "slidePopup", translate: '100%', duration: 350})]
})
export class SendFeedbackComponent implements OnInit, OnDestroy {
  public feedbackForm: FormGroup;
  public activeSupportType: any;
  public supportTypes: any;
  public isLogin: boolean = false;
  public isShowDialog: boolean = false;
  public isSubmitForm: boolean = false;
  private subscription: Subscription = new Subscription();

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly notification: NotificationService,
    private readonly _location: PlatformLocation,
    private readonly location: Location,
    private readonly router: Router,
    private readonly log: LogService,
    private readonly http: HttpService,
    private readonly userServices: UserService,
    private readonly tokenService: TokenService,
    private readonly indicator: IndicatorService,
    private readonly cache: CacheObjectService<any>,
    private readonly fb: FormBuilder,
    private readonly eventTracker: EventTrackerService,
    private readonly render: Renderer2
  ) {
    this.feedbackForm = this.fb.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.pattern(validationPattern.email)]],
      supportType: ['', [Validators.required]],
      phone: [''],
      description: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.subscription.add(this.tokenService.isLogin$.subscribe(c => {
      this.isLogin = c;
      if (this.isLogin) {
        this.userServices.getUserData().subscribe((res) => {
          const _user: UserModel = res;
          const _name: string = _user.firstName ? _user.firstName : '';
          const _family: string = _user.lastName ? _user.lastName : '';
          let name: string | null = null;
          if (_user.firstName || _user.lastName) {
            name = (_name ?? '') + ' ' + (_family ?? '');
          }
          this.feedbackForm.patchValue({
            name,
            email: _user.email,
            phone: _user.mobileNo
          });
          this.indicator.hide();
        });
      }
    }));
    this.cache.getObjectCache(`/api/contacts/support-types`).subscribe(c => {
      this.getSupportTypes(c);
      this.indicator.hide();
    })
  }

  private getSupportTypes(res) {
    this.supportTypes = res.map(z => ({id: z.identifier, title: z.title}));
    this.feedbackForm.patchValue({
      supportType: this.supportTypes[0].id
    });
    this.activeSupportType = this.supportTypes.find(c => c.id === this.feedbackForm.get('supportType')?.value);
  }

  public sendMessage() {
    if (this.feedbackForm.valid) {
      this.isSubmitForm = true;
      const url = `/api/contacts`;
      let params = this.toHttpParams(this.feedbackForm.getRawValue());
      this.http.post(url, params.toString(), 'application/x-www-form-urlencoded')
        .subscribe(res => {
          this.isSubmitForm = false;
          this.log.logger(res);
          this.onShowNotification({text: 'نظرات شما ارسال شد', type: 'info'});
          this.eventTracker.logEvent('x_action_result', {
            x_action_name: 'success_feedback',
            x_action_result: 'success'
          });
          this.router.navigate(["./profile"]);
        }, err => {
          this.isSubmitForm = false;
          this.log.logger(err);
          this.indicator.hide();
          this.onShowNotification({text: err?.error?.message, type: 'error'});
          this.eventTracker.logEvent('x_action_result', {x_action_name: 'error_feedback', x_action_result: 'error'});
        });
    } else {
      this.eventTracker.logEvent('x_action_result', {x_action_name: 'error_feedback', x_action_result: 'error'});
      this.onShowNotification({text: 'تمام زمینه ها را وارد کنید.', type: 'error'});
    }
  }

  private toHttpParams(obj: object): HttpParams {
    return Object.getOwnPropertyNames(obj)
      .reduce((p, key) => p.set(key, obj[key]), new HttpParams());
  }

  public closeDialog() {
    this.render.removeStyle(this.document.body, 'overflow');
    if (this.location.path(true).includes('#modalOpened'))
      this.location.back();
    this.isShowDialog = false;
  }

  public openDialog() {
    this.render.setStyle(this.document.body, 'overflow', 'hidden');
    this._location.pushState(null, null, this.location.path() + '#modalOpened');
    this.isShowDialog = true;
  }

  public saveSubjectType() {
    this.activeSupportType = this.supportTypes.find(c => c.id === this.activeSupportType.id);
    this.feedbackForm.get('supportType').setValue(this.activeSupportType.id);
    this.closeDialog();
  }

  public onShowNotification(e: iNotification) {
    this.notification.setNotification(e);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
